"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchClient = void 0;
const react_1 = require("react");
const utils_1 = require("../utils");
function useSearchClient(settings) {
    return (0, react_1.useMemo)(() => (0, utils_1.getSearchClient)(settings), [settings]);
}
exports.useSearchClient = useSearchClient;
//# sourceMappingURL=useSearchClient.js.map